import { createContext } from "react";

export interface FeedbackProviderContextValues {
  feedback: string | undefined;
  setFeedback: React.Dispatch<React.SetStateAction<string | undefined>>;
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const FeedbackProviderContext = createContext<FeedbackProviderContextValues>({
  feedback: undefined,
  setFeedback: () => {},
  showModal: false,
  setShowModal: () => {},
});
FeedbackProviderContext.displayName = "FeedbackProviderContext";

export default FeedbackProviderContext;
